import { Typography } from 'antd';
import React from 'react';

const { Text } = Typography;
import styles from './styles.module.scss';

const InstructorInfo: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => {
  return (
    <div className={styles['instructor-info__info']}>
      <Text className={styles['instructor-info__label']}>{label}</Text>
      <Text className={styles['instructor-info__content']}>{value}</Text>
    </div>
  );
};

export default InstructorInfo;
